import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SiteLayoutComponent } from './core/layout/site-layout/site-layout.component';
import { PageLayoutComponent } from './core/layout/page-layout/page-layout.component';
import { NotfoundComponent } from './core/error/notfound/notfound.component';
import { PortalLayoutComponent } from './core/layout/portal-layout/portal-layout.component';
import { VendorLayoutComponent } from './core/layout/vendor-layout/vendor-layout.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { AuthGuard } from './auth/auth.guard';
import { CallbackComponent } from './auth/callback.component';
import { SignoutCallbackComponent } from './auth/signout-callback.component';

const routes: Routes = [
  { path: 'signin-callback', component: CallbackComponent },
  { path: 'signout-callback', component: SignoutCallbackComponent },

  {
    path: 'account',
    loadChildren: () =>
      import('./security/security.module').then(m => m.SecurityModule),
  },

  // ✅ SINGLE ROOT LAYOUT
  {
    path: '',
    component: SiteLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // Home
      {
        path: '',
        loadChildren: () =>
          import('./home/home.module').then(m => m.HomeModule),
      },

      // Other site pages
      {
        path: 'x',
        component: PageLayoutComponent,
        loadChildren: () =>
          import('./xui/xui.module').then(m => m.XuiModule),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./pages/pages.module').then(m => m.PagesModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then(m => m.AdminModule),
      },
      {
        // path: 'reports',
        // component: ReportsComponent,
        // loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        path: 'reports',
    loadChildren: () =>
    import('./reports/reports.module').then(m => m.ReportsModule),
      },
      {
        path: 'system',
        loadChildren: () =>
          import('./system/system.module').then(m => m.SystemModule),
      },
      {
        path: 'integrations',
        loadChildren: () =>
          import('./integrations/integrations.module').then(m => m.IntegrationsModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./notifications/notifications.module').then(m => m.NotificationsModule),
      },
    ],
  },

  // Separate layouts (NOT children of SiteLayout)
  {
    path: 'portal',
    component: PortalLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./portal/portal.module').then(m => m.PortalModule),
  },
  {
    path: 'vendor',
    component: VendorLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./vendor/vendor.module').then(m => m.VendorModule),
  },

  { path: '**', component: NotfoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking', // ✅ REQUIRED (Angular 15+)
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
